<template>
  <div class="page-wrapper">
    <el-row class="common-row">
      <el-col :span="19" :xs="{ span: 24 }" class="common-col-left">
        <router-view />
      </el-col>
      <el-col :span="5" :xs="{ span: 24 }" class="common-col-right">
        <div class="right-content-wrapper">
          <div v-if="displayForm.client">
            <div class="text-select-label">{{ $t('scheduleAppointment.selectRightSponsorLabel') }}</div>
            <div class="text-select-value">{{ displayForm.client }}</div>
          </div>
          <div v-if="displayForm.program">
            <div class="text-select-label">{{ $t('scheduleAppointment.selectRightProgramLabel') }}</div>
            <div class="text-select-value">{{ displayForm.program }}</div>
          </div>
          <div v-if="displayForm.eligid">
            <div class="text-select-label">{{ $t('scheduleAppointment.selectRightQualificationLabel') }}</div>
            <div class="text-select-value">{{ displayForm.eligid }}</div>
          </div>
          <div v-if="displayForm.exam">
            <div class="text-select-label">{{ $t('scheduleAppointment.selectRightTestLabel') }}</div>
            <div class="text-select-value">{{ displayForm.exam }}</div>
          </div>
          <div v-if="displayForm.examAddress">
            <div class="text-select-label">考试中心位置</div>
            <div class="text-select-value">{{ displayForm.examAddress }}</div>
          </div>
          <div v-if="displayForm.examDateFormat">
            <div class="text-select-label">考试日期：</div>
            <div class="text-select-value">{{ displayForm.examDateFormat }}</div>
          </div>
          <div v-if="displayForm.examTime">
            <div class="text-select-label">考试时间：</div>
            <div class="text-select-value">{{ displayForm.examTime }}</div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'ScheduleView',
  components: {},
  data() {
    return {}
  },
  computed: {
    ...mapGetters(['userInfo', 'examInfo']),
    displayForm() {
      return this.examInfo || {}
    },
  },
  methods: {
    backHandler() {
      this.$router.go(-1)
    },
    nextHandler() {},
  },
}
</script>
<style scoped lang="less">
.right-content-wrapper {
  padding: 20px;
  .text-select-label {
    font-size: 20px;
  }
  .text-select-value {
    font-size: 20px;
    margin: 8px 0 10px;
  }
}
</style>
